export default __webpack_public_path__ + "static/media/Tamas.150b9c8f.jpg";